var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMasterBadge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 65,
    viewBox: "0 0 60 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5487 60.4552C37.4281 60.8244 37.2984 57.5589 45.6332 52.6534C47.5973 46.2857 50.0898 30.6792 50.4872 20.043C44.5839 16.9176 37.1588 15.0824 29.2553 14.7871C21.5199 14.498 14.1063 15.7365 8.0313 18.3301C7.77365 25.2247 7.63779 31.1135 7.95375 36.1772C9.81659 51.315 21.4949 60.229 27.5487 60.4552Z",
    fill: "url(#paint0_linear_180_295)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0283 62.3128C48.4618 57.3931 49.878 45.4057 50.858 20.3092C44.9546 17.1838 37.5296 15.3487 29.626 15.0533C21.8906 14.7642 14.477 16.0028 8.40203 18.5964C7.50303 43.7801 7.97546 55.9222 28.0283 62.3128ZM29.5553 16.9451C36.7022 17.2122 43.3378 18.7652 48.8785 21.4561C47.9163 44.9535 46.4195 55.717 28.1037 60.2949C10.1387 54.3612 9.45259 43.4319 10.2919 19.8458C15.9292 17.6989 22.5766 16.6843 29.5553 16.9451Z",
    fill: "url(#paint1_linear_180_295)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.978 63.6582L27.6448 63.5615C17.5779 60.3226 11.9056 55.5219 9.15674 47.9676C6.56351 40.756 6.66632 31.2455 7.1392 18.5914L7.16905 17.7926L7.93834 17.4845C14.2687 14.8163 21.7679 13.5389 29.7136 13.8358C37.7853 14.1374 45.3349 16.0193 51.4873 19.2382L52.1894 19.6013L52.1596 20.4C51.6478 32.9685 51.0826 42.4617 47.9163 49.4581C44.6113 56.7862 38.5965 61.1502 28.3595 63.5882L27.978 63.6582ZM9.63333 19.4423C8.76732 43.7432 9.40358 54.8811 28.0365 60.966C47.1153 56.2482 48.5374 45.2294 49.4828 21.0578C43.8207 18.2361 36.9359 16.5895 29.5368 16.313C22.3479 16.0444 15.4871 17.1352 9.63333 19.4423Z",
    fill: "url(#paint2_linear_180_295)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_180_295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8291 44L26.4399 39.6058L17.9007 39.6058C17.1167 39.6058 16.4865 39.1377 16.4865 38.5554L16.4865 24.0504C16.4865 23.4681 17.1167 23 17.9007 23L39.8904 23C40.6744 23 41.3046 23.4681 41.3046 24.0504L41.3046 38.5554C41.3046 39.1377 40.6744 39.6058 39.8904 39.6058L32.8193 39.6058L20.8291 44Z",
    fill: "url(#paint3_linear_180_295)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.662 44L26.057 38.8838L17.8463 38.8838C17.0925 38.8838 16.4865 38.436 16.4865 37.8791L16.4865 24.0047C16.4865 23.4477 17.0925 23 17.8463 23L38.9902 23C39.7441 23 40.3501 23.4477 40.3501 24.0047L40.3501 37.8791C40.3501 38.436 39.7441 38.8838 38.9902 38.8838L32.1911 38.8838L20.662 44Z",
    fill: "url(#paint4_linear_180_295)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2652 19.223L51.9817 23.0003L56.9816 16.9999L50.2652 19.223Z",
    fill: "url(#paint5_linear_180_295)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.457 21.6965L56.9817 17L48.9572 18.158L51.457 21.6965Z",
    fill: "url(#paint6_linear_180_295)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.96426 20.1288L9.48166 16.8871L1.55207 15.5724L6.96426 20.1288Z",
    fill: "url(#paint7_linear_180_295)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.62882 17.9999L1.5521 15.5725L6.98166 21.8009L8.62882 17.9999Z",
    fill: "url(#paint8_linear_180_295)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8845 19.3658L28.863 1.41406L22.2528 7.40794L28.8845 19.3658Z",
    fill: "url(#paint9_radial_180_295)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.7596 8.66583L28.8844 19.3656L43.7401 13.5105L41.7596 8.66583Z",
    fill: "url(#paint10_radial_180_295)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8844 19.366L35.5555 7.34895L28.863 1.41431L28.8844 19.366Z",
    fill: "url(#paint11_radial_180_295)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8845 19.3657L22.2529 7.40787L15.8846 8.63494L28.8845 19.3657Z",
    fill: "url(#paint12_radial_180_295)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5554 7.34875L28.8843 19.3658L41.7596 8.66602L35.5554 7.34875Z",
    fill: "url(#paint13_radial_180_295)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8843 19.3659L15.8844 8.63513L13.9462 13.2925L28.8843 19.3659Z",
    fill: "url(#paint14_radial_180_295)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.7095 6.20214L28.7014 5.02768L28.7561 12.9444L28.7095 6.20214Z",
    fill: "url(#paint15_radial_180_295)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_180_295",
    x: 16.4865,
    y: 23,
    width: 35.8182,
    height: 25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 11,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_180_295"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_180_295",
    x1: 37.4865,
    y1: 61,
    x2: 12.4865,
    y2: 16.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#053BE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BB3F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_180_295",
    x1: 11.4865,
    y1: 37.8929,
    x2: 51.4865,
    y2: 37.8929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.163159,
    stopColor: "#FFEA8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267469,
    stopColor: "#E3AB29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6592,
    stopColor: "#FFEA8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3A922"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_180_295",
    x1: 15.9865,
    y1: 17,
    x2: 18.9865,
    y2: 33.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3073,
    stopColor: "#E3AB29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6592,
    stopColor: "#FFEA8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3A922"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_180_295",
    x1: 25.6584,
    y1: 21.7885,
    x2: 28.7754,
    y2: 39.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FDE587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0002,
    stopColor: "#FFEA8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#FFEA8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#E3A922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489483,
    stopColor: "#E3A923"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "#E3A922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.760417,
    stopColor: "#E3AB29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973958,
    stopColor: "#E3A922"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_180_295",
    x1: 28.8955,
    y1: 37.7955,
    x2: 15.5101,
    y2: 26.3847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3AB29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.602928,
    stopColor: "#FFEA8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771173,
    stopColor: "#FFCF25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEA8F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_180_295",
    x1: 53.7144,
    y1: 19.0824,
    x2: 53.9096,
    y2: 23.1219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42B7E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_180_295",
    x1: 50.0285,
    y1: 16.5958,
    x2: 53.3937,
    y2: 18.839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85D5F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_180_295",
    x1: 5.03753,
    y1: 17.2644,
    x2: 8.37603,
    y2: 14.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42B7E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_180_295",
    x1: 4.85037,
    y1: 21.7067,
    x2: 4.99816,
    y2: 17.6651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85D5F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_180_295",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.1438 2.18657) rotate(60) scale(24.0043 24.0043)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8FF0FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E93B3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_180_295",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.2616 9.06193) rotate(60) scale(17.6256 17.6255)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85D5F2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_180_295",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.5064 2.77197) rotate(60) scale(27.7937 27.7937)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85D5F2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_180_295",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.91944 11.0789) rotate(60) scale(20.3698 20.3697)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85D5F2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_180_295",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.7623 9.65411) rotate(60) scale(21.7173 21.7173)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42B7E3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_180_295",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.7257 9.02883) rotate(60) scale(28.1508 28.1508)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46DAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C7A94"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_180_295",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.1561 4.95607) rotate(60) scale(11.5642 11.5642)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD58C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00185873,
    stopColor: "#99FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterBadge);
export default __webpack_public_path__ + "static/media/master-badge.bc6f3afd6980962bdd58dad984e69cf6.svg";
export { ForwardRef as ReactComponent };